<div class="aeg-label-above-layout">
    <label v-if="!modHiddenLabel" :for="name">
        {{label}}
        <span v-if="modRequired" style="color: var(--p-message-error-simple-color)">*</span>
    </label>
    <slot :has-errors="hasError"></slot>
    <Message v-if="annotation" severity="secondary" variant="simple" size="small">{{annotation}}</Message>
    <Message v-if="hasError" severity="error" variant="simple" size="small">
        {{ errors[0] }}
    </Message>
</div>
